import { render } from "./CarCoupon.vue?vue&type=template&id=e1b70fde&scoped=true"
import script from "./CarCoupon.vue?vue&type=script&lang=js"
export * from "./CarCoupon.vue?vue&type=script&lang=js"

import "./CarCoupon.vue?vue&type=style&index=0&id=e1b70fde&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b70fde"]])

export default __exports__